// extracted by mini-css-extract-plugin
export var code = "Sketch-module--code--ng0+c";
export var codeVisible = "Sketch-module--codeVisible--qcgOt";
export var editorBtn = "Sketch-module--editorBtn--9ciBb";
export var left = "Sketch-module--left--IaBdm";
export var right = "Sketch-module--right--QLYGu";
export var root = "Sketch-module--root--c+j1q";
export var splash = "Sketch-module--splash--rex4Y";
export var wrapper = "Sketch-module--wrapper--j5fOq";